import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import EstimateForm from '../../components/feature/EstimateForm';
import FinalCTA from '../home/components/FinalCTA';
import { services } from '../../mocks/services';

export default function ServicesPage() {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <div className="min-h-screen font-sans">
      <Header onEstimateClick={() => setFormOpen(true)} />
      <main>
        {/* Hero */}
        <section className="relative pt-40 pb-24 px-6 overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/8dd0a5aa2d44b034d9cc5a4e74e12ce7.jpg"
              alt="Hardwood flooring services Maryland"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/70" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
          </div>
          <div className="relative max-w-4xl mx-auto text-center">
            <nav className="flex justify-center gap-2 text-sm text-white/70 font-sans mb-8">
              <Link to="/" className="hover:text-gold transition-colors">Home</Link>
              <span>/</span>
              <span className="text-gold">Services</span>
            </nav>
            <h1
              className="font-serif text-5xl md:text-6xl text-white font-bold leading-tight mb-5"
              style={{ textShadow: '0 2px 16px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.9)' }}
            >
              Hardwood Flooring Services
              <span className="block text-gold text-4xl md:text-5xl mt-2">in Maryland</span>
            </h1>
            <p
              className="font-sans text-lg text-white leading-relaxed max-w-2xl mx-auto mb-10"
              style={{ textShadow: '0 1px 8px rgba(0,0,0,0.8)' }}
            >
              From new installation to expert refinishing, repair, and full replacement — Premier Hardwood Floors delivers precision craftsmanship for Maryland homeowners.
            </p>
            <button
              onClick={() => setFormOpen(true)}
              className="px-10 py-4 bg-gold text-walnut font-semibold rounded-lg hover:bg-gold-dark transition-colors font-sans text-base whitespace-nowrap"
            >
              Get a Free Estimate
            </button>
          </div>
        </section>

        {/* Services */}
        <section className="bg-white py-24 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((svc) => (
                <div key={svc.id} className="group bg-sand rounded-2xl overflow-hidden border border-sand-dark hover:border-oak/40 transition-all">
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={svc.image}
                      alt={svc.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-walnut/60 to-transparent" />
                    <div className="absolute bottom-5 left-5">
                      <div className="w-12 h-12 flex items-center justify-center bg-gold/90 rounded-xl">
                        <i className={`${svc.icon} text-walnut text-xl`} />
                      </div>
                    </div>
                  </div>
                  <div className="p-8">
                    <h2 className="font-serif text-2xl text-walnut font-bold mb-3">{svc.name}</h2>
                    <p className="font-sans text-sm text-charcoal/70 leading-relaxed mb-5">{svc.fullDesc}</p>
                    <ul className="space-y-2 mb-7">
                      {svc.benefits.slice(0, 3).map((b) => (
                        <li key={b} className="flex items-center gap-2.5 text-sm font-sans text-charcoal/70">
                          <i className="ri-checkbox-circle-line text-gold text-base flex-shrink-0" />
                          {b}
                        </li>
                      ))}
                    </ul>
                    <button
                      onClick={() => setFormOpen(true)}
                      className="w-full flex items-center justify-center gap-2 py-3.5 bg-walnut text-white rounded-lg font-sans text-sm font-semibold hover:bg-walnut-dark transition-colors whitespace-nowrap"
                    >
                      <i className="ri-file-list-3-line" /> Get a Free Estimate
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <FinalCTA
          onEstimateClick={() => setFormOpen(true)}
          heading="Ready to Get Started?"
          subtext="Contact Premier Hardwood Floors today for a free, no-obligation estimate on any of our Maryland hardwood flooring services."
        />
      </main>
      <Footer onEstimateClick={() => setFormOpen(true)} />
      <EstimateForm isOpen={formOpen} onClose={() => setFormOpen(false)} />
    </div>
  );
}
